module.exports = __webpack_public_path__ + "static/media/icon_edit_pencil.a923b471.svg";